import { UseProposalsScreen } from './ProposalsScreen.types'

export const useProposalsScreen: UseProposalsScreen = ({ navigation, route }) => {
  return {}
}
